import React, { useEffect, useRef, useState } from "react"
import { Modal, Button } from "react-bootstrap"

const ConfirmModal: React.FC<{
  isShow: boolean
  submitHandler: React.MouseEventHandler<HTMLElement>
  hideHandler: (isCancel: boolean) => void
}> = (props) => {
  const 処理中Ref = useRef<NodeJS.Timeout>()
  const はいButton = useRef<HTMLButtonElement>(null)
  const [is処理中, setIs処理中] = useState(false)
  useEffect(() => {
    setIs処理中(false)
    if (props.isShow) {
      はいButton?.current?.focus()
    }
  }, [props.isShow])

  return (
    <Modal
      show={props.isShow}
      onHide={props.hideHandler}
      dialogClassName={["popupMenu"].join(" ")}
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton={false}>
        <Modal.Title>{is処理中 ? "処理中" : "確認"}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ width: "100%" }}>
        {/* left:12を持っているため強制的に0に変更。また、styleをあてるためにspinnerの中身だけを移植 */}
        <div
          style={{ left: "0" }}
          className={is処理中 ? "spinner fade is-show" : "spinner fade"}></div>
        {props.children}
      </Modal.Body>
      <Modal.Footer>
        {!is処理中 && props.isShow ? (
          <>
            <Button
              type="submit"
              variant="primary"
              ref={はいButton}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()

                if (処理中Ref.current) {
                  clearTimeout(処理中Ref.current)
                }
                処理中Ref.current = setTimeout(() => {
                  props.submitHandler(e)
                }, 250)
                setIs処理中(true)
              }}>
              はい
            </Button>
            <Button
              variant="pending"
              onClick={(e) => {
                props.hideHandler(false)
                return
              }}>
              いいえ
            </Button>
          </>
        ) : (
          <></>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmModal
